<template>
  <div class="five-app">
    <div class="app-top">
      <h3>应用场景</h3>
      <span></span>
    </div>
    <span class="app-text">
      提供多样化的应用场景，满足不同行业的使用
    </span>
    <article class="app-content">
      <div class="article-top clearfix">
        <a
          v-for="app in appList"
          :key="app.id"
          @click="active(app.id)"
          :class="{ active: number == app.id }"
        >
          {{ app.text }}</a
        >
      </div>
      <div
        class="article-content clearfix"
        v-for="(item, index) in appList.slice(number, number + 1)"
        :key="index"
      >
        <div class="left clearfix">
          <div class="top clearfix">
            <div>
              <img :src="item.topimg" />
            </div>
            <h3>{{ item.text }}</h3>
          </div>
          <div class="bottom clearfix">
            <h4
              class="left-1 clearfix"
              v-for="child1 in item.child1"
              :key="child1.id"
            >
              <span>{{ child1.span1 }}</span>
              <span>{{ child1.span2 }}</span>
            </h4>
            <h4 class="left-2 clearfix" v-if="item.span != ''">
              <span>{{ item.span }}</span>
              <span
                class="left-span"
                v-for="child2 in item.child2"
                :key="child2.id"
                >{{ child2.text }}</span
              >
            </h4>
            <h4 class="left-3" @click="jumpService()">{{ item.button }}</h4>
          </div>
        </div>
        <div class="right clearfix">
          <img :src="item.rightimg" />
        </div>
      </div>
    </article>
    <div class="app-back clearfix"></div>
  </div>
</template>
<script>
export default {
  name: "fiveApp",
  data() {
    return {
      number: 0,
      appList: [
        {
          id: 0,
          text: "品牌推广",
          topimg: require("../../static/images/fiveG/app/pptg.png"),
          child1: [
            {
              id: 0,
              span1: "场景描述：",
              span2: "企业要塑造自身及产品的品牌形象，增加品牌的曝光率，提示品牌的知名度和影响力，并在消费者中得到广泛的认同",
            },
            {
              id: 1,
              span1: "场景应用：",
              span2: "视频短信及图文短信丰富的内容，承载了更多的品牌优势和差异化信息，并且传播速度快、影响范围广，可在用户终端长期存储",
            }
          ],
          span: "适用行业：",
          child2: [
            {
              id: 0,
              text: "汽车行业"
            },
            {
              id: 1,
              text: "地产行业"
            },
            {
              id: 2,
              text: "美妆行业"
            },
            {
              id: 3,
              text: "数码行业"
            },
          ],
          button: "立即体验",
          rightimg: require("../../static/images/fiveG/app/1-pptg.png")
        },
        {
          id: 1,
          text: "产品推广",
          topimg: require("../../static/images/fiveG/app/cptg.png"),
          child1: [
            {
              id: 0,
              span1: "场景描述：",
              span2: "新产品要向市场进行发布或者公开，增强产品曝光度与影响力，并在一定程度上覆盖消费者群体，获得消费者的初步认知",
            },
            {
              id: 1,
              span1: "场景应用：",
              span2: "视频短信及图文短信丰富的内容，承载了更多的新产品信息，并且传播速度快、影响范围广，可直接购买",
            }
          ],
          span: "适用行业：",
          child2: [
            {
              id: 0,
              text: "汽车行业"
            },
            {
              id: 1,
              text: "地产行业"
            },
            {
              id: 2,
              text: "美妆行业"
            },
            {
              id: 3,
              text: "数码行业"
            },
          ],
          button: "立即体验",
          rightimg: require("../../static/images/fiveG/app/2.png")
        },
        {
          id: 2,
          text: "活动营销",
          topimg: require("../../static/images/fiveG/app/hd.png"),
          child1: [
            {
              id: 0,
              span1: "场景描述：",
              span2: "企业或门店要提高知名度，需要通过科学的渠道吸引客流到访，以增长盈利额",
            },
            {
              id: 1,
              span1: "场景应用：",
              span2: "视频短信及图文短信有着丰富的内容，承载了更多的活动营销信息，并且传播速度快、影响范围广，可直接领取活动优惠卷至线下门店核销",
            }
          ],
          span: "适用行业：",
          child2: [
            {
              id: 0,
              text: "汽车美容行业"
            },
            {
              id: 1,
              text: "美容美甲行业"
            },
            {
              id: 2,
              text: "餐饮行业"
            },
            {
              id: 3,
              text: "数码城行业"
            },
          ],
          button: "立即体验",
          rightimg: require("../../static/images/fiveG/app/3.png")
        },
        {
          id: 3,
          text: "公共宣传",
          topimg: require("../../static/images/fiveG/app/ggxc.png"),
          child1: [
            {
              id: 0,
              span1: "场景描述：",
              span2: "企业或单位要宣传组织形象，以便为企业单位及其产品建立良好的公众形象",
            },
            {
              id: 1,
              span1: "场景应用：",
              span2: "视频短信及图文短信丰富的内容，承载了更多的品牌优势和差异化信息，并且传播速度快、影响范围广，可在用户终端长期存储",
            }
          ],
          span: "适用行业：",
          child2: [
            {
              id: 0,
              text: "汽车行业"
            },
            {
              id: 1,
              text: "地产行业"
            },
            {
              id: 2,
              text: "政府单位"
            },
          ],
          button: "立即体验",
          rightimg: require("../../static/images/fiveG/app/4.png")
        },
        {
          id: 4,
          text: "景区介绍",
          topimg: require("../../static/images/fiveG/app/jq.png"),
          child1: [
            {
              id: 0,
              span1: "场景描述：",
              span2: "旅游景区要有较强交互能力的旅游信息主动推送服务系统。以互动式旅游知识共享平台和导游手段为表现内容，且能够加载文字、图像和音视频等数据",
            },
            {
              id: 1,
              span1: "场景应用：",
              span2: "视频短信及图文短信丰富的内容，承载了更多的品牌优势和差异化信息，并且传播速度快、影响范围广，可在用户终端长期存储",
            }
          ],
          span: "适用行业：",
          child2: [
            {
              id: 0,
              text: "旅游行业"
            },
            {
              id: 1,
              text: "景区管理行业"
            },
          ],
          button: "立即体验",
          rightimg: require("../../static/images/fiveG/app/5.png")
        },
        {
          id: 5,
          text: "党政宣传",
          topimg: require("../../static/images/fiveG/app/dzxc.png"),
          child1: [
            {
              id: 0,
              span1: "场景描述：",
              span2: "城市形象宣传，对外城市的宣传，包括旅游景区城市文化等；政府招商引资，用于对外企业的招商引资，促进经济发展；政府部分对外职能公布，政府的安全、交通等部门对外的政策公布，以及指令下达；方便有效的传递；政府对外公益的宣传，包括爱护环境、注意防盗、遇到灾难的解决方法等",
            },
            {
              id: 1,
              span1: "场景应用：",
              span2: "视频短信及图文短信丰富的内容，承载了更多的品牌优势和差异化信息，并且传播速度快、影响范围广，可在用户终端长期存储",
            }
          ],
          span: "",
          button: "立即体验",
          rightimg: require("../../static/images/fiveG/app/6.png")
        },
        {
          id: 6,
          text: "公益知识普及",
          topimg: require("../../static/images/fiveG/app/gy.png"),
          child1: [
            {
              id: 0,
              span1: "场景描述：",
              span2: "政府或者企事业单位要营造健康向上的人文环境、有利于青少年健康成长的文化环境、舒适便利的生活环境、安全稳定的社会环境、可持续发展的生态环境、扎实有效的创建活动，需要公益知识普及",
            },
            {
              id: 1,
              span1: "场景应用：",
              span2: "视频短信及图文短信丰富的内容，承载了更多的品牌优势和差异化信息，并且传播速度快、影响范围广，可在用户终端长期存储",
            }
          ],
          span: "适用行业：",
          child2: [
            {
              id: 0,
              text: "政府单位"
            },
            {
              id: 1,
              text: "传媒行业"
            },
            {
              id: 2,
              text: "慈善行业"
            },
          ],
          button: "立即体验",
          rightimg: require("../../static/images/fiveG/app/7.png")
        },
      ]
    }
  },
  methods: {
    active: function (index) {
      this.number = index;
    },
    jumpService() {
      this.$addConsult()
    },
  }
}
</script>
<style lang="stylus" scoped>
.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

h4 {
  font-weight: 400;
}

.five-app {
  width: 1400px;
  height: 900px;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 40px;
  text-align: center;
  box-sizing: border-box;
}

.app-top h3 {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 2px;
}

.app-top span {
  display: block;
  margin: 20px auto 0;
  content: '';
  width: 42px;
  height: 4px;
  border-bottom: 2px solid #ffc000;
}

.app-text {
  display: inline-block;
  font-size: 18px;
  margin-top: 20px;
}

.app-content {
  width: 1400px;
  margin: 45px auto;
  position: relative;
  z-index: 2;

  .article-top {
    display: block;
    width: 1060px;
    font-size: 16px;
    margin: 0 auto;

    a {
      display: inline-block;
      width: 134px;
      height: 46px;
      text-decoration: none;
      color: black;
      cursor: pointer;
      line-height: 46px;
      box-sizing: border-box;
      margin-left: 20px;
    }

    a:first-child {
      margin: 0;
      float: left;
    }

    a:last-child {
      float: right;
    }

    .active {
      color: white;
      background-color: #FFC000;
      border-radius: 23px;
    }
  }

  .article-content {
    position: relative;
    display: block;
    width: 1060px;
    height: 430px;
    margin: 0 auto;
    margin-top: 74px;
    border: 1px solid #F3F3F3;
    box-shadow: 2px 2px 10px #E0E0E0;
    background-color: #fff;
    box-sizing: border-box;

    .left {
      display: inline-block;
      width: 75%;
      height: 300px;
      box-sizing: border-box;
      float: left;
      margin-top: 130px;

      .top {
        width: 100px;
        height: 100px;
        position: relative;
        top: -180px;

        div {
          display: inline-block;
          width: 100px;
          height: 100px;
          line-height: 100px;
          position: absolute;
          left: 480px;
          border: 1px solid #F3F3F3;
          border-radius: 50%;
          box-shadow: 0 5px 10px #FFD65A;
          background-color: #fff;
          box-sizing: border-box;

          img {
            vertical-align: middle;
          }
        }

        h3 {
          display: block;
          width: 123px;
          text-align: center;
          position: absolute;
          top: 136px;
          left: 470px;
          font-size: 20px;
          font-weight: bold;
        }
      }

      .bottom {
        display: block;
        width: 70%;
        margin-left: 90px;
        text-align: left;
        position: absolute;
        top: 136px;

        .left-1 {
          display: block;
          line-height: 24px;

          span {
            display: inline-block;
            float: left;
            margin: 9px 0;
          }

          span:last-child {
            width: 86%;
          }
        }

        .left-2 {
          display: block;
          height: 40px;
          line-height: 40px;
          margin: 15px 0;

          span {
            display: inline-block;
            float: left;
          }

          .left-span {
            text-align: center;
            display: inline-block;
            width: 100px;
            height: 40px;
            line-height: 40px;
            color: #FFC000;
            border-radius: 40px;
            background-color: #FFF9E5;
            margin-left: 15px;
            font-size: 12px;
          }

          span:nth-child(2) {
            margin-left: 5px;
          }
        }

        .left-3 {
          text-align: center;
          display: block;
          width: 120px;
          height: 40px;
          font-size: 16px;
          margin-top: 16px;
          line-height: 40px;
          float: left;
          background-color: #FFC000;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }

    .right {
      display: inline-block;
      width: 25%;
      float: left;

      img {
        display: inline-block;
        position: relative;
        top: 31px;
        right: 6px;
      }
    }
  }
}

.app-back {
  width: 1400px;
  height: 300px;
  background-color: #F5F5F5;
  margin: 0 auto;
  position: relative;
  z-index: 0;
  top: -266px;
}
</style>


// WEBPACK FOOTER //
// src/components/pc/FiveApp.vue